/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Where a card sits in a layout being saved. It names an existing placement, which is moved or resized; a new card is added with addWidget.
 */
export type PlacementInput = {
  /**
   * Height in rows; each chart type also has a minimum
   */
  h: number;
  /**
   * The placement being moved or resized
   */
  id: string;
  /**
   * Width in columns; each chart type also has a minimum, so x + w stays within 12
   */
  w: number;
  widgetId: string;
  /**
   * Column the card starts at, on a 12-column grid
   */
  x: number;
  /**
   * Row the card starts at
   */
  y: number;
};

/** @internal */
export type PlacementInput$Outbound = {
  h: number;
  id: string;
  w: number;
  widget_id: string;
  x: number;
  y: number;
};

/** @internal */
export const PlacementInput$outboundSchema: z.ZodMiniType<
  PlacementInput$Outbound,
  PlacementInput
> = z.pipe(
  z.object({
    h: z.int(),
    id: z.string(),
    w: z.int(),
    widgetId: z.string(),
    x: z.int(),
    y: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      widgetId: "widget_id",
    });
  }),
);

export function placementInputToJSON(placementInput: PlacementInput): string {
  return JSON.stringify(PlacementInput$outboundSchema.parse(placementInput));
}
